<template>
  <SAIInput
    :class="[
      'pin-input text-weight-medium',
      { 'pin-input-value': value, 'pin-input--locked': lock }
    ]"
    v-on="$listeners"
    v-bind="$attrs"
    :disable="disable || lock"
    :value="lock ? undefined : value"
    type="text"
    mask="######"
    maxlength="6"
    :clearable="false"
    :placeholder="lock ? undefined : 'PIN'"
    :error="error"
    :dense="false"
  >
    <template v-slot:prepend v-if="lock">
      <QIcon
        color="grey-5"
        class="absolute-center"
        size="24px"
        name="eva-lock-outline"
      />
    </template>
  </SAIInput>
</template>

<script>
import { QIcon } from 'quasar';
import { SAIInput } from 'ecx.saigon.ui.common';

export default {
  name: 'PinInput',
  props: {
    value: undefined,
    error: Boolean,
    lock: Boolean,
    disable: Boolean
  },
  components: {
    SAIInput,
    QIcon
  }
};
</script>

<style lang="sass" scoped>
.pin-input::v-deep
  width: 190px

  .q-field__control
    padding-right: 3px !important

  input
    text-align: center
    font-size: 28px !important
    color: $primary

.pin-input.q-field--error::v-deep
  input
    color: $negative

.pin-input.pin-input--locked::v-deep
  .q-field__control
    background: $grey-3

.pin-input-value::v-deep input
  letter-spacing: 10px
</style>
